import { createContext } from 'react';

import { AltinnClient } from '../../api';
import { OnescoreClient } from '../../api/Onescore';
import {
    RequestID,
    UpscoreClient,
} from '../../api/Upscore';
import { StoryblokClient } from '../../storyblok';

interface Context {
    Altinn: AltinnClient;
    Upscore: UpscoreClient;
    Storyblok: StoryblokClient;
    fetchUserScoreData: () => Promise<{
        requestID: RequestID;
        scoreData: any;
    }> | any;
    getRequestID: () => Promise<string | void | null>;
    Onescore: OnescoreClient
}

export const ApiContext = createContext<Context>(undefined!);
